import BoardNotFoundError from '../../boards/errors/BoardNotFoundError'
import { BaseMoveError } from '../../errors/BaseMoveError'
import SwimlaneNotFoundError from '../../swimlanes/errors/SwimlaneNotFoundError'

/**
 * Possible errors associated with a swimlane move
 */
enum SwimlaneMoveErrorTypes {
    FromBoard,
    FromSwimlane,
    ToBoard,
    ToSwimlane,
}

/**
 * Error thrown if an exception takes place whilst processing
 * a swimlane move request.
 * Underlying error can be one of the following:
 * BoardNotFound -> For both source and destination boards
 * SwimlaneNotFound -> For both source and destination boards
 */
class SwimlaneMoveError extends BaseMoveError<
    SwimlaneMoveErrorTypes,
    BoardNotFoundError | SwimlaneNotFoundError
> {}

export { SwimlaneMoveError, SwimlaneMoveErrorTypes }
